<template>
  <v-menu
    ref="datepicker"
    v-model="datepicker"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :id="id"
        :label="label"
        :loading="loading"
        :disabled="disabled"
        :rules="rules"
        readonly
        flat
        solo
        dense
        color="cyan"
        class=""
        :class="className"
        :placeholder="btxPlaceholder"
        hide-details
        :clearable="clearable"
        @click:clear="clearDate"
        :prepend-inner-icon="hidePrefixIcon ? '' : 'mdi-calendar'"
        v-bind="attrs"
        v-on="on"
        :value="formattedDate"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      no-title
      :min="minDate"
      :max="maxDate"
      color="cyan"
      :first-day-of-week="weekday"
      :disabled="disabled"
      :readonly="readonly"
      @input="datepicker = false"
    ></v-date-picker>
  </v-menu>
</template>

<script>
import moment from "moment-timezone";
import { mapGetters } from "vuex";

moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);

export default {
  name: "date-picker",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: {
      type: [Date, String],
      default: null,
    },
    hidePrefixIcon: {
      type: Boolean,
      default: false,
    },
    minDate: {
      type: [Date, String],
      default: null,
    },
    maxDate: {
      type: [Date, String],
      default: null,
    },
    rules: {
      type: [Array, Object],
      default: () => {
        return [];
      },
    },
    placeholder: {
      type: String,
      default: "Date",
    },
    id: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    contentClass: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    className: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      date: null,
      datepicker: false,
      timeout: null,
    };
  },
  watch: {
    minDate() {
      this.date = null;
    },
    maxDate() {
      this.date = null;
    },
    date() {
      this.emitValue();
    },
    value() {
      this.date = this.value;
    },
  },
  methods: {
    clearDate() {
      this.date = null;
    },
    debounceGetAppConfig() {
      const _this = this;
      if (_this.localConfigDBLoading) {
        return false;
      }

      _this.$store
        .dispatch("setLocalConfig")
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    getAppConfig() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.debounceGetAppConfig();
      }, 500);
    },
    emitValue() {
      /* this.dateFormatted = this.formatDate(this.date); */
      this.$emit("input", this.date);
      this.$emit("change", this.date);
    },
    formatDate(date) {
      if (!date) return null;
      return moment(date).format(this.dateFormat);
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
  },
  computed: {
    ...mapGetters(["localConfigDB", "localConfigDBLoading"]),
    btxPlaceholder() {
      return this.placeholder + " [DD/MM/YYYY]";
    },
    formattedDate() {
      if (this.date) {
        return moment(this.date).format(this.dateFormat);
      }
      return this.date;
    },
    weekday() {
      const config = this.localConfigDB;
      return config && config.weekday == 1 ? 0 : 1;
    },
    dateFormat() {
      return this.localConfigDB?.date_format ?? "DD/MM/YYYY";
    },
    dateTimeFormat() {
      return this.dateTimeFormat + " " + this.timeFormat;
    },
    timeFormat() {
      return this.localConfigDB?.time_format ?? "HH:mm";
    },
  },
  mounted() {
    this.date = this.value;
    this.$nextTick(() => {
      this.emitValue();
    });
    this.getAppConfig();
  },
};
</script>
